import React from 'react';
import { Spinner } from '../spinner/spinner';
import { SpinnerType } from '../../../theme/type/spinner-type';
import { cn } from '../../../utils/tailwind';

interface LoadingPropsInterface {
    children?: React.ReactNode;
    spinner?: SpinnerType;
    active?: boolean;
    fullWidth?: boolean;
    fullHeight?: boolean;
}

export const Loading: React.FC<LoadingPropsInterface> = ({
    children,
    spinner = 'default',
    active = false,
    fullWidth,
    fullHeight,
}) => {
    return (
        <div className={cn('relative', fullWidth && 'w-full', fullHeight && 'h-full')}>
            {children && <div className={cn('h-full transition-[filter]', active && 'blur-[0.2rem]')}>{children}</div>}
            <div
                className={cn(
                    'pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 transition-[background-color,opacity,visibility]',
                    active && 'pointer-events-auto visible bg-body/40 opacity-100',
                )}
            >
                <Spinner type={spinner} />
            </div>
        </div>
    );
};
